import React, {PureComponent, PropTypes} from 'react';
import merge from 'lodash/merge';
import {Container} from 'flux/utils';

import style from './comments.module.css';
import {
    addComment,
    replyActive
} from './comments.actions';
import CommentsStore from './comments.store';

class Comments extends PureComponent {

    static propTypes = {
        type: PropTypes.string,
        id: PropTypes.number
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    static getStores() {
        return [CommentsStore];
    }

    static calculateState(prevState) {
        return {
            loading: CommentsStore.loading,
            comments: CommentsStore.comments,
            users: CommentsStore.users,
            addingComment: CommentsStore.addingComment,
            activeReply: CommentsStore.activeReply
        };
    }

    _submitForm = (e) => {
        e.preventDefault();

        const text = this._textarea.value;

        if (!text) {
            return;
        }

        const reply = parseInt(e.target.dataset.reply, 10) || 0;
        let rootParent = 0;

        if (reply) {
            const comment = this.state.comments.find((item) => {
                return item.get('id') === reply
            });

            if (comment) {
                rootParent = comment.get('root_parent') || reply;
            }
        }

        addComment({
            type: this.props.type,
            id: this.props.id,
            text,
            parent: reply,
            rootParent
        });
    };

    _addReply = (e) => {
        e.preventDefault();

        replyActive(parseInt(e.target.dataset.reply, 10));
    };

    _renderAddForm(reply) {
        return (<div key={'form' + reply} className={style.addComment}>
                    <form data-reply={reply} onSubmit={this._submitForm}>
                        <textarea ref={(node) => {this._textarea = node;}} placeholder={Exanimo.trans('enter_comment')} className={style.textarea}/>
                        <div className={style.submitContainer}>
                            <input className={style.submit} value={Exanimo.trans('post_message')} type="submit"/>
                        </div>
                    </form>
                </div>);
    }

    _printCommentList(parent, commentItems = []) {

        let comments = [];

        this.state.comments.map((item) => {

            if (item.get('parent') !== parent) {
                return;
            }

            const user = this.state.users.get(item.get('user_id') + '');

            if (!user) {
                return;
            }

            comments.push(
                <div className={style.comment} key={'comment' + item.get('id')}>
                    <div className={style.avatarContainer}>
                        <a style={{backgroundImage: `url(${user.get('small_avatar')})`}} className={style.avatar}/>
                    </div>
                    <div className={style.commentContent}>
                        <div className={style.author}>
                            <a className={style.username}>{user.get('username')}</a>
                            <span className={style.time}>{item.get('created_at')}</span>
                            {!!Exanimo.userId && <a href="" data-reply={item.get('id')} onClick={this._addReply} className={style.reply}/>}
                        </div>
                        <div className={style.content}>
                            {item.get('text')}
                        </div>
                    </div>
                </div>);

            if (item.get('id') === this.state.activeReply) {
                comments.push(this._renderAddForm(this.state.activeReply));
            }

            this._printCommentList(item.get('id'), comments);
        });

        if (!comments.length) {
            return;
        }

        if (parent) {
            commentItems.push(<div key={'level' + parent} className={style.commentLevel}>
                                {comments}
                              </div>);
        } else {
            return merge(commentItems, comments);
        }
    }

    render() {

        const commentItems = this._printCommentList(0);

        if (this.state.loading) {
            return (<div className="loading-container">
                        <div className="loading-wheel"/>
                    </div>);
        }

        return (
            <div className={style.comments}>
                <div className="small-header">{Exanimo.trans('comments')}</div>
                {!!Exanimo.userId &&
                    this._renderAddForm()
                }

                {!Exanimo.userId &&
                    <div className={style.needLogin}>
                        {Exanimo.trans('login_to_comment')}
                    </div>
                }

                {commentItems}
            </div>
        );
    }
}

export default Container.create(Comments);